import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import AppPopover from "@components/popover/app-popover";
import { getTopicflowIcon } from "@components/topicflow-icon/topicflow-icon-helpers";

import ChatHistoryList from "./chat-history-list";

const ChatHistoryPopover = ({
  children,
  onClickChatSessionId,
}: {
  children?: React.ReactNode;
  onClickChatSessionId?: (chatSessionId: number | null) => void;
}) => {
  const content = (
    <ChatHistoryList
      onClickChatSessionId={onClickChatSessionId}
      className="px-4 py-3 max-h-[500px] w-96 overflow-y-auto"
    />
  );

  return (
    <AppPopover content={content}>
      {children ? (
        children
      ) : (
        <AppPopover.Button
          as={Button}
          icon={getTopicflowIcon("previous")}
          theme={buttonTheme.iconGray}
          size={ButtonSize.medium}
          aria-label="Chat history"
        />
      )}
    </AppPopover>
  );
};

export default ChatHistoryPopover;
